import { useMemo } from "react";

import { Table } from "antd";
import TableAntd from "components/elements/Table/Table";
import { useTranslation } from "react-i18next";


const MyTeamWorkScheduleTable = (
  { columns = [], isLoading = false, dataSource = [], onPageChange = () => { }, pagination = {} }
) => {
  const { t } = useTranslation()
  const scroll = useMemo(() => {
    return {
      x: 3000,
      // y: 2000,
      scroll: true
    };
  }, []);

  return (
    <TableAntd
      loading={isLoading}
      dataSource={dataSource}
      columns={columns}
      scroll={scroll}
      onChange={onPageChange}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
    />
  );
};

export default MyTeamWorkScheduleTable;
